import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = React.createElement("path", { d: "M2 11h20v2H2z" });
export default createSvgIcon(iconPath, "Minus");
//# sourceMappingURL=MinusIcon.js.map